export function toStateKey(key: string | null | undefined): string {
  return String(key);
}
